import { makeAutoObservable } from 'mobx';

class AttractionStore {
  EXPECTED_AREA="5a2e47ba142d58464cbac7e0"
  items = [];
  loading = true;
  imageHeaderContent = {}
  tourCategories = []
  defaultCategories = []
  allAttractions = []
  freeAttractions =[]
  praguAreas = []
  attractionTitles = {}
  isConstructionPageVisible = false
  category = "all"
  passCardCategories = []

  constructor() {
    makeAutoObservable(this);
    this.fetchImageHeaderContent();
    this.fetchCategories();
    this.fetchAllAttractions();
    this.fetchPragueAreas();
    this.fetchAttractionTitles();
    this.fetchPassCardCategories();
  }

  fetchPassCardCategories = async () =>{
    this.loading = true;
    this.passCardCategories = [];
  
    try {
      const response = await fetch(`https://api2.praguecoolpass.com/cardCategories?eshopId=77a85a2a-6b84-4d79-b856-dfafc14340a0`);
      const data = await response.json();
      this.passCardCategories = data || []; 
    } catch (error) {
      console.error('Failed to fetch search results:', error);
    } finally {
      this.loading = false;
    }
  }

  changeCategory = async (value) =>{
    this.category=value;
    
  }

  setIsConstructionPageVisible = async (value) =>{
    this.isConstructionPageVisible = value
  }

  fetchSearchResults = async (query) => {
    this.loading = true;
    this.items = [];
  
    try {
      const response = await fetch(`https://api2.praguecoolpass.com/search?lang=en&q=${query}`);
      const data = await response.json();
      this.items = data || [];
    } catch (error) {
      console.error('Failed to fetch search results:', error);
    } finally {
      this.loading = false;
    }
  };
  

  fetchAttractionTitles = async ()=>{
    this.loading = true;
    this.attractionTitles ={}

    try {
      const response = await fetch('https://api2.praguecoolpass.com/pages/5fe31408c1478823bac06380');
      const data = await response.json();
      this.attractionTitles = data;

    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  }

  fetchPragueAreas = async () => {
    this.loading = true;
    this.praguAreas = []

    try {
      const response = await fetch('https://api2.praguecoolpass.com/area');
      const data = await response.json();
      const sortedData = data.sort((a, b) => a.order - b.order);

      this.praguAreas = sortedData;
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  }

  fetchAllAttractions = async () => {
    this.loading = true;
    this.allAttractions = []
    this.freeAttractions=[]

    try {
      const response = await fetch('https://api2.praguecoolpass.com/object/attraction/');
      const data = await response.json();
      await data.map(async(item)=>{
        if(item.benefit == "Free Public Entry"){
          this.freeAttractions.push(item)
        }else{
          this.allAttractions.push(item)
        }
      })
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  }

  fetchFreeAttractions = async () => {
    this.loading = true;
    this.freeAttractions = []

    try {
      const response = await fetch('https://api2.praguecoolpass.com/object/attraction/'); 
      const data = await response.json();
      await data.map(async(item)=>{
        if(item.benefit == "Free Public Entry"){
          await this.freeAttractions.push(item)
        }
      })
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  }


  fetchCategories = async () => {
    this.loading = true;
    this.tourCategories = []
    this.defaultCategories = []
    try {
      const response = await fetch('https://api2.praguecoolpass.com/category');
      const data = await response.json();
      data.map((item)=>{
        if(item?.isTour){
          this.tourCategories.push(item);
        }else{
          this.defaultCategories.push(item);
        }
      })

    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  }

  fetchImageHeaderContent = async () => {
    this.loading = true;
    try {
      const response = await fetch('https://api2.praguecoolpass.com/pages/5fe31408c1478823bac06380'); 
      const data = await response.json();
      this.imageHeaderContent = data;
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  }
  
  fetchItems = async () => {
    this.loading = true;
    try {
      const response = await fetch('YOUR_API_ENDPOINT_HERE'); 
      const data = await response.json();
      this.items = data;
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  };
}

const attractionStore = new AttractionStore();
export default attractionStore;
